export const REMOVE_AGENT_START = 'REMOVE_AGENT_START';
export const REMOVE_AGENT_SUCCESS = 'REMOVE_AGENT_SUCCESS';
export const REMOVE_AGENT_ERROR = 'REMOVE_AGENT_ERROR';
